const arrayToOptions = (type?: any) => (value: any) => {
  if (type) {
    return {
      label: value,
      value,
      type,
    }
  } else {
    return {
      label: value,
      value,
    }
  }
}

export default arrayToOptions
